var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      attrs: { id: _vm.role.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("roles.show") || _vm.$_can("roles.view-own")
        }
      }
    },
    [
      [
        _c(
          "div",
          {
            staticClass: "d-flex list-box-header col-12 pointer",
            on: {
              mouseup: function($event) {
                if ("button" in $event && $event.button !== 1) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.viewMiddle($event, _vm.role.id)
              },
              click: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "left", 37, $event.key, [
                    "Left",
                    "ArrowLeft"
                  ])
                ) {
                  return null
                }
                if ("button" in $event && $event.button !== 0) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                _vm.view($event, _vm.role.id)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "pl-0 list-box-header-left col-lg-7 col-7 pr-3" },
              [
                _c(
                  "div",
                  { staticClass: "pl-0 d-flex align-items-center col-7" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", { staticClass: "ref-id" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.role.name) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pl-0 d-flex align-items-center col-5" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "list-box-status align-items-start col-12"
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.role.carrier_id) +
                              "\n            "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-box-header-right col-lg-5 col-5 pl-4" },
              [
                _c("div", { staticClass: "d-flex align-items-center col-7" }, [
                  _c("div", { staticClass: "role-roles" }, [
                    _vm.role.department &&
                    _vm.role.department.name === "Dispatch"
                      ? _c("span", { staticClass: "dispatch-roles" }, [
                          _vm._v("\n              Dispatch\n            ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.role.department &&
                    _vm.role.department.name === "Management"
                      ? _c("span", { staticClass: "management" }, [
                          _vm._v("\n              Management\n            ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.role.department && _vm.role.department.name === "Sales"
                      ? _c("span", { staticClass: "sales-roles" }, [
                          _vm._v("\n              Sales\n            ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.role.department && _vm.role.department.name === "Claims"
                      ? _c("span", { staticClass: "claims-roles" }, [
                          _vm._v("\n              Claims\n            ")
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c658f47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c658f47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/UserRoles/SettingsUserRolesBlock.vue
// module id = null
// module chunks = 